'use client';

import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('[global-error]', error);
    // Best-effort HyperDX report without importing client modules that need providers
    void import('@/lib/telemetry/hyperdx')
      .then(({ reportErrorToHyperDX }) => {
        reportErrorToHyperDX(error, { boundary: 'global', digest: error.digest });
      })
      .catch(() => undefined);
  }, [error]);

  return (
    <html lang="en">
      <body>
        <div style={{ padding: 32, fontFamily: 'system-ui, sans-serif' }}>
          <h2>Something went wrong</h2>
          <p>{error.message}</p>
          <button type="button" onClick={reset}>
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
